import styled from "@emotion/styled";
import { mediaQueries } from "@stepfinance/react";

import { DangerousPlatformTag } from "../shared";

export const genHeader = (icon: string, title: string) => (
  <StyledHeader>
    <PlatformIcon src={icon} alt="dashboard-module" />
    <DangerousPlatformTag platform={title} />
  </StyledHeader>
);

export const genBalance = (balance: string) => {
  return <StyledBalance>{balance}</StyledBalance>;
};

const PlatformIcon = styled.img`
  border-radius: 50%;
`;

const StyledHeader = styled.h2`
  display: flex;
  font-size: 14px;
  ${mediaQueries[2]} {
    font-size: 21px;
  }
  font-weight: bold;
  float: left;
  color: #fff;

  > span {
    margin: auto 0;
  }

  img {
    margin: auto 10px auto 0;
    height: 21px;
    width: 21px;

    ${mediaQueries[2]} {
      height: 27px;
      width: 27px;
    }
  }
`;

const StyledBalance = styled.h2`
  font-size: 14px;
  ${mediaQueries[2]} {
    font-size: 21px;
  }
  font-weight: bold;
  float: right;
  color: #fff;
`;
